import { Moment } from 'moment';
import { ISurveyDurationTypes } from './ISurveyDurationTypes';
import { IRoundFrequency } from './IRoundFrequency';
import { ISurveyRoundDurationTypes } from './ISurveyRoundDurationTypes';

export enum ISchedulingFormNames {
	surveyName = 'surveyName',
	clientId = 'clientId',
	partnerId = 'partnerId',
	offices = 'offices',
	sendRespondentCount = 'sendRespondentCount',

	repetitiveType = 'repetitiveType',
	startDate = 'startDate',
	endDate = 'endDate',

	roundFrequency = 'roundFrequency',
	surveyDuration = 'surveyDuration',
	// Reminder Block
	surveyRoundDuration = 'surveyRoundDuration',
	remindersFrequency = 'remindersFrequency',
	sendingTime = 'sendingTime',
}

export enum IValidationSchedulingFormNames {
	employeesLimitByOffice = 'employeesLimitByOffice',
}

export interface ISchedulingForm {
	[ISchedulingFormNames.surveyName]: string;
	[ISchedulingFormNames.clientId]: string;
	[ISchedulingFormNames.partnerId]?: string;
	[ISchedulingFormNames.offices]: string[];
	[ISchedulingFormNames.sendRespondentCount]: string;
	[ISchedulingFormNames.repetitiveType]: IRepetitiveTypes;

	[ISchedulingFormNames.startDate]: Moment;

	[ISchedulingFormNames.surveyDuration]: ISurveyDurationTypes;
	[ISchedulingFormNames.surveyRoundDuration]: ISurveyRoundDurationTypes; // 1 - weekly, 2 - twoweeks
	[ISchedulingFormNames.roundFrequency]: IRoundFrequency;
	[ISchedulingFormNames.sendingTime]: Moment;
	[ISchedulingFormNames.remindersFrequency]: IReminderFrequencyTypes;
	// validation
	[IValidationSchedulingFormNames.employeesLimitByOffice]: number;
}

export enum IRepetitiveTypes {
	repetitive = 'repetitive',
	single = 'single',
}

export enum IReminderFrequencyTypes {
	eachDay = 'each_day',
	eachTwoDays = 'each_two_days',
}
